<template>
  <div class="home">
    <homeContainer curNav="首页">
      <el-carousel class="banner" height="480px" arrow="always">
        <el-carousel-item v-for="item in [banner,banner,banner]" :key="item">
          <img :src="item"  />
        </el-carousel-item>
      </el-carousel>
      <div class="container_content main flex">
        <div class="flex">
          <Headset />
          <div>7x24小时客户服务<br />
            <span class="address">中山市横栏镇西区街道长安北路盛雅华庭7栋102</span>
          </div>
        </div>
        <div class="flex">
          <Headset />
          <div>24大行业解决方案<br />
            <span class="address">丰富的行业解决方案，以一流的产品和服务终结企业管理混乱的现状</span>
          </div>
        </div>
        <div class="flex">
          <Headset />
          <div>12大核心产品<br />
            <span class="address">12大核心产品，解决中小微企业内部采购管理，对外产品销售</span>
          </div>
        </div>
      </div>
      <aboutUs showTitle />
    </homeContainer>
  </div>
</template>

<script setup>
import { ref,defineComponent  } from 'vue'
import homeContainer from "@/components/homeContainer.vue";
import aboutUs from "@/components/aboutUs.vue";
import banner from "@/assets/images/qb.jpg";
import banner2 from "@/assets/images/gd.jpg";
import banner3 from "@/assets/images/kd.jpg";
import banner4 from "@/assets/images/cg.jpg";
defineComponent({
  components: { aboutUs, homeContainer }
})

</script>

<style scoped lang="scss">
.home {
  .banner {
    max-width: 1920px;
    margin: 0 auto;
    &> :deep(.el-carousel__arrow) {
      background: $master-color;
    }
  }
  .container_content {
    position: relative;
    z-index: 9;
    height: 150px;
    margin-top: -75px;
    background: #fff;
    box-shadow: 0 5px 20px 0 rgba(0,0,0,.09);
    >div {
      flex: 1;
      height: 100%;
      border-right: 2px #f4f4f4 solid;
      padding-right: 16px;
      font-size: 16px;
      svg {
        width: 50px;
        margin: 0 30px;
        color: $font-color;
      }
      .address {
        font-size: 13px;
        color: $font-color;
      }
    }
  }
  .recommend {
    gap: 10px;
    margin: 20px auto;
    a {
      flex: 1;
      img {
        width: 100%;
        height: 150px;
      }
      &:first-child {
        cursor: auto;
      }
    }
  }
  .soft {
    gap: 10px;
    align-items: flex-start;
    .goods {
      flex: 1;
      border: solid 1px $border-color;
      .tabs {
        gap: 2px;
        height: 38px;
        line-height: 38px;
        a {
          display: block;
          color: #000;
        }
        &>div {
          background: $bg2-color;
          width: 140px;
          height: 100%;
          &:first-child {
            width: 180px;
            background: none;
          }
          &.active {
            background: $master-color;
            color: #fff;
          }
        }
      }
      .list {
        background: $assistant-color;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        .item {
          border-right: solid 1px $border-color;
          border-bottom: solid 1px $border-color;
          &:nth-child(3n) {
            border-right: none;
          }
          img {
            width: 160px;
            height: 160px;
          }
          .flex-column {
            height: 100%;
            justify-content: space-around;
            align-items: flex-start;
            span:first-child {
              color: $master-color;
            }
            span:nth-child(2) {
              font-size: 12px;
            }
            p:last-child {
              font-size: 12px;
              padding: 2px 5px;
              border-radius: 6px;
              color: #fff;
              background: $red;
            }
          }
        }
      }
    }
    .sidebar {
      width: 245px;
      margin-bottom: 20px;
      .content {
        width: 100%;
        background: $assistant-color;
        &:first-child {
          margin-bottom: 10px;
        }
        .title {
          padding: 0 10px;
          box-sizing: border-box;
          height: 33px;
          line-height: 33px;
          background: $bg2-color;
          .bold {
            font-size: 12px;
            color: $master-color;
          }
          span:last-child {
            font-size: 12px;
            color: $font-color;
            float: right;
            i {
              vertical-align: middle;
            }
          }
        }
        a {
          margin: 0 8px;
          padding-left: 10px;
          display: block;
          font-size: 12px;
          line-height: 28px;
          color: #323232;
          position: relative;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            background: #000;
            position: absolute;
            border-radius: 50%;
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}
</style>
